module.exports = __webpack_public_path__ + "static/assets/382b599bee886b33356d977723d9bdff.svg";